import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {Store} from '@ngrx/store';
import {HttpService} from '../../../services/http/http.service';
import {IMenuItem} from '../../../interfaces/main-menu';
import * as SettingsActions from '../../../store/actions/app-settings.actions';
import {IAppState} from '../../../interfaces/app-state';
import * as PageActions from '../../../store/actions/page.actions';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {UserService} from '../../../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import { element } from 'protractor';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [
    trigger('subMenu', [
        state('active', style({
          height: '*',
          visibility: 'visible'
        })),
        state('inactive', style({
          height: 0,
          visibility: 'hidden'
        })),
        transition('inactive => active', animate('200ms ease-in-out')),
        transition('active => inactive', animate('200ms ease-in-out')),
      ]
    )]
})
export class MenuComponent implements OnInit {
  @HostBinding('class.main-menu') true;

  @HostBinding('class.horizontal') get horizontal() {
    return this.orientation === 'horizontal';
  }

  @HostBinding('class.vertical') get vertical() {
    return this.orientation === 'vertical';
  }

  @Input() orientation: string;
  @Input() src: string;
  menuItems: IMenuItem[];
  caret: string;
  distinctThings:any[];
  distinctThings_:any[];

  constructor(
    private httpSv: HttpService,
    private store: Store<IAppState>,
    private router: Router,
    public user: UserService,
    private translate: TranslateService
  ) {
    this.caret = 'icofont-thin-right';
    // console.log(this.orientation, 'orientation');
    // this.orientation = 'vertical';
  }

  ngOnInit() {
    
    if (this.user.authenticated) {
      this.getMenuData(this.src);

    } else {
      this.user.getUserInfo(true).then(value => {
        this.getMenuData(this.src);

      });
    }

    this.langChangeSubscriber();
  

  }

  langChangeSubscriber() {
    this.user.lang_event.subscribe(value => {
      this.menuItems.forEach((v, k) => {
        
        const menu_subs = Object.values(v.sub || {});
        menu_subs.forEach(x=>{
          const key_sub = `HOME.menu.${x.routing}`;
          console.log('kkiii',key_sub);
          
          this.translate.get(key_sub)
          .subscribe(res => {

            x.title = res
            console.log('translatedsub', res);
           
          });
        })
        
       
        const key = `HOME.menu.${v.routing}`;
        console.log('kk',key);
        
        this.translate.get(key)
          .subscribe(res => {
            // const usub  = v.sub.forEach(i=>{
            //   console.log('testi',i.routing);
              
            // })
            console.log('translated', res);
            this.menuItems[k].title = res !== key ? res : v.title;
          });
      });
    });
  }

  
  getMenuData(url: string) {
    this.httpSv.getData(url).subscribe(
      (data: IMenuItem[]) => {

        this.menuItems = this.user.setMenuItems(data);
       // console.log("menu all+ data", url, data);
        console.log('menu###',this.menuItems );
      },
      err => {
        console.log(err);
      }
    );
  }

  toggle(event: Event, item: any, el: any) {
    event.preventDefault();

    let items: any[] = el.menuItems;
    console.log('item###',items );
    console.log('subitem',item.r_menu );
    if (item.active) {
      item.active = false;
    } else {
      for (let i = 0; i < items.length; i++) {
        items[i].active = false;
      }
      item.active = true;
    }

    this.changeRoute(
      item.routing,
      !item.sub && !this.isActive([this.orientation, item.routing]),
      item.layout ? item.layout : this.orientation
    );
  }

  subState(item: IMenuItem, rla: boolean) {
    return item.active || rla ? 'active' : 'inactive';
  }

  closeAll() {
    this.menuItems.forEach(item => {
      item.active = false;

      this.closeSub(item);
    });
  }

  closeSub(item: IMenuItem) {
    if (item.sub && item.sub.length) {
      
      item.sub.forEach(subItem => {
        subItem.active = false;
      });
    }
  }

  closeSidebar() {
    this.store.dispatch(new SettingsActions.SidebarState(false));
  }

  // change route
  changeRoute(routing: string, bool: boolean = true, layout: string = this.orientation) {
    if (bool) {
      this.store.dispatch(new PageActions.Reset());

      setTimeout(() => {
        this.router.navigate([`./${layout}`, routing]);
      }, 0);
    }
  }

  isActive(instruction: any[]): boolean {
    return this.router.isActive(this.router.createUrlTree(instruction), true);
  }
}
